module.exports = __webpack_public_path__ + "img/act-找工作.666efafd.png";